import { patch } from "@/shared/axios";
import useBranchId from "@/shared/hooks/useBranchId";
import { useMutation } from "@tanstack/react-query";

interface UsePosSessionPayParams {
  session_id: number;
  payment_method: number;
  name?: string;
  phone?: string;
  email?: string;
  tip?: string;
}

const usePosSessionPay = () => {
  const branchId = useBranchId();
  const mutation = useMutation({
    mutationFn: ({ session_id, ...body }: UsePosSessionPayParams) =>
      patch(
        `/internal/secure/pos/v1/order/sessions/pay/session/${branchId}/${session_id}`,
        {
          ...body,
        }
      ),
  });
  return mutation;
};

export default usePosSessionPay;
